import { useEffect } from "react";
import { useFormContext } from "react-hook-form";
export const HiddenInput = ({ source, value }) => {
    const form = useFormContext();
    useEffect(() => form.setValue(source, value), [form, source, value]);
    return null;
};
